// extracted by mini-css-extract-plugin
export default {"mainLoginCardWrapper":"login_mainLoginCardWrapper__TAEnK","mainLoginCard":"login_mainLoginCard__Cslu9"};